"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Telemetry_1 = __importDefault(require("Settings/Telemetry"));
var ButtonType;
(function (ButtonType) {
    ButtonType["None"] = "none";
    ButtonType["Unavailable"] = "unavailable";
    ButtonType["HitLimit"] = "hit limit";
    ButtonType["Zapier"] = "zapier";
    ButtonType["Custom"] = "custom";
    ButtonType["Internal"] = "internal";
    ButtonType["Salesforce"] = "salesforce";
})(ButtonType || (ButtonType = {}));
var FocusEnableButton = (function () {
    function FocusEnableButton(make, $timeout, createUi, integrationService, initSubscription, Button, integration, enable) {
        var _this = this;
        var settingsTelemetry = make(Telemetry_1.default);
        var getButtonType = function () {
            var buttonType;
            if (integrationService.isEnabled(integration.internalName)) {
                buttonType = ButtonType.None;
            }
            else if (integrationService.needsUpselling(integration)) {
                buttonType = ButtonType.Unavailable;
            }
            else if (integrationService.hasReachedCategoryLimit(integration)) {
                buttonType = ButtonType.HitLimit;
            }
            else if (integration.customButton) {
                buttonType = ButtonType.Custom;
            }
            else if (integration.zapierName != null) {
                buttonType = ButtonType.Zapier;
            }
            else if (integration.name == "Salesforce") {
                buttonType = ButtonType.Salesforce;
            }
            else {
                buttonType = ButtonType.Internal;
            }
            return buttonType;
        };
        var internalEnableButton = new Button(function () {
            enable();
        }, "Enable ".concat(integration.name), {
            theme: "primary",
            size: "medium",
        });
        var upgradeAccountButton = new Button(function () {
            initSubscription.init();
        }, "Upgrade Account", {
            theme: "primary",
            size: "medium",
        });
        var hitLimitEnableButton = new Button(function () { }, "Enable ".concat(integration.name), {
            theme: "primary",
            size: "medium",
            initialState: "disabled",
        });
        var connectZapierButton = new Button(function () {
            if (integration.zapierName != null) {
                settingsTelemetry.trackConnectToZapierButtonClicked(integration.internalName);
            }
        }, "Connect to Zapier", {
            theme: "primary",
            size: "medium",
            href: function () {
                var baseUrl = "https://zapier.com/apps/qwilr/integrations/";
                if (!!integration.zapierName) {
                    return "".concat(baseUrl).concat(integration.zapierName, "/");
                }
                else {
                    return baseUrl;
                }
            },
        });
        var connectSalesforceButton = new Button(null, "View in AppExchange", {
            theme: "primary",
            size: "medium",
            href: function () {
                return "https://appexchange.salesforce.com/appxListingDetail?listingId=a0N3A00000EOLEPUA5";
            },
        });
        this.ui = createUi(require("./FocusEnableButton.html"), {
            getButtonType: getButtonType,
            integration: integration,
            enable: enable,
            internalEnableButton: internalEnableButton,
            hitLimitEnableButton: hitLimitEnableButton,
            connectZapierButton: connectZapierButton,
            upgradeAccountButton: upgradeAccountButton,
            connectSalesforceButton: connectSalesforceButton,
            upgradeMessage: "",
        });
        var getUpgradeMessage = function () { return __awaiter(_this, void 0, void 0, function () {
            var plans, message, i;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, integrationService.getAvailablePlans(integration)];
                    case 1:
                        plans = _a.sent();
                        message = ["Available for "];
                        for (i = 0; i < plans.length - 1; i++) {
                            message.push(plans[i]);
                            message.push(", ");
                        }
                        if (plans.length > 1) {
                            message[message.length - 1] = " and ";
                        }
                        message.push(plans[plans.length - 1]);
                        message.push(" customers");
                        this.ui.upgradeMessage = message.join("");
                        $timeout();
                        return [2];
                }
            });
        }); };
        if (getButtonType() === ButtonType.Unavailable) {
            getUpgradeMessage();
        }
    }
    return FocusEnableButton;
}());
exports.default = FocusEnableButton;
